import Select from '@rio-cloud/rio-uikit/Select';
import type { ComponentProps } from 'react';

import FormGroup from '@/components/ui/FormGroup';

type SelectInputProps = {
    selectAttributes: ComponentProps<typeof Select>;
} & ComponentProps<typeof FormGroup>;

const SelectInput = ({ label, id = `${label}-select`, selectAttributes, ...formGroupProps }: SelectInputProps) => (
    <FormGroup {...formGroupProps} label={label}>
        <Select {...selectAttributes} id={id} />
    </FormGroup>
);
export default SelectInput;
